if(typeof hls.js === 'undefined') {var e = new Error("Cannot find module 'hls.js'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = hls.js;